import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {FormsValidatorService} from '../../services/forms-validator.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-dropdown-multiselect',
  templateUrl: './dropdown-multiselect.component.html',
  styleUrls: ['./dropdown-multiselect.component.css'],
})
export class DropdownMultiselectComponent implements OnInit {

  @Input() dmCloseOnSelect: boolean;
  @Input() dmPlaceholder: string;
  @Input() dmBindLabel: string;
  @Input() dmBindValue: string;
  @Input() dmId: string;
  @Input() dmSelectedItems = [];
  @Input() itemsData: [];
  @Input() dmNgModel: any[];
  @Input() isRequired: boolean;
  @Input() isDisable: boolean;
  @Input() resetSelectedValue?: boolean;
  @Input() disable: Observable<boolean>;
  @Input() dmDropdownPosition = 'auto';

  @Output() selected = new EventEmitter<number[]>();
  @Output() isValid = new EventEmitter<boolean>();

  genericFormGroup: FormGroup;

  constructor(private formBuilder: FormBuilder) { }

  get formData() { return this.genericFormGroup.controls; }

  ngOnInit() {
    this.initializeForm();
    this.selected.emit(this.dmSelectedItems);

    if (this.disable) {
      this.disable.subscribe(val => {
        if (val) {
          this.genericFormGroup.get('ngGenericSelect').disable();
        } else {
          this.genericFormGroup.get('ngGenericSelect').enable();
        }

      });
    }
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (this.genericFormGroup) {
  //     setTimeout(() => {
  //       if (changes['itemsData']) {
  //         this.disabledConditions();
  //       }
  //     }, 300);
  //   }
  // }


  disabledConditions() {
    if (this.genericFormGroup) {

      if (this.isRequired && this.itemsData && this.itemsData.length > 0 && this.isDisable) {
        // quando é requerido, tem todos os dados e está desabilitado (qdo depende de um outro campo para preenchimento da lista)
        this.genericFormGroup.get('ngGenericSelect').enable();
      } else {
        if (this.isDisable) {
          this.genericFormGroup.get('ngGenericSelect').disable();
        } else {
          this.genericFormGroup.get('ngGenericSelect').enable();
        }
      }
    }
  }

  initializeForm() {
    this.genericFormGroup = this.formBuilder.group({
      ngGenericSelect: [[], Validators.required]
    });
    this.disabledConditions();
    if (this.isRequired !== undefined && !this.isRequired) {
      FormsValidatorService.removeValidator( this.genericFormGroup, 'ngGenericSelect');
    }
  }

  onSelectAll(availableItems: any[]) {
    const selected = availableItems.map(item => item[this.dmBindValue]);
    this.genericFormGroup.get('ngGenericSelect').patchValue(selected);
    this.selected.emit(this.genericFormGroup.value.ngGenericSelect);
    this.isValid.emit(this.genericFormGroup.valid);
  }

  onClearAll() {
    this.genericFormGroup.get('ngGenericSelect').patchValue([]);
    this.selected.emit(this.genericFormGroup.value.ngGenericSelect);
    this.isValid.emit(this.genericFormGroup.valid);
  }

  changeValue() {
    this.selected.emit(this.genericFormGroup.value.ngGenericSelect);
    this.isValid.emit(this.genericFormGroup.valid);
  }

  reset() {
    this.genericFormGroup.reset();
  }

}
